import { getPrestTotalPrice, getPriceAccommodationOnly } from "@/logic/pricesAndDiscount"

export default {
	totals: (state, getters) => {
		const selectedPrestations = getters.selectedPrestations

		const participants = state.participants

		let totalPrice = 0
		let crossedPrice = 0

		let firstAccommodation = true;
		selectedPrestations.forEach((prestObj) => {
			let quantity = prestObj.quantity
			if (firstAccommodation) {
				firstAccommodation = false;
				totalPrice += getPrestTotalPrice(prestObj.prestation);
				crossedPrice += prestObj.prestation.crossedPrice
				quantity -= 1;
			}
			if (prestObj.prestation.priceAccommodationOnly) {
				totalPrice += quantity * getPriceAccommodationOnly(prestObj.prestation);
			} else {
				totalPrice += quantity * getPrestTotalPrice(prestObj.prestation);
			}				
			crossedPrice += quantity * prestObj.prestation.crossedPrice;
		})

		let maxPromo = parseInt((1 - totalPrice / crossedPrice) * 100)

		let perPrice = totalPrice / participants.length

		const obj = {}

		obj["totalPrice"] = totalPrice
		obj["perPrice"] = perPrice
		if (maxPromo >= 5) obj["crossedPrice"] = crossedPrice
		if (maxPromo >= 5) obj["maxPromo"] = maxPromo

		return obj
	},
}
